<template>
  <div class="built-progress" ref="progress">
    <button v-for="step in steps" :key="step.index" :class="{active: isActive(step), current: isCurrent(step)}" :style="buttonStyle" :disabled="!isActive(step)">
      <span v-if="isDone(step)">✓</span>
      <span v-else>{{step.index + 1}}</span>
      {{step.title}}
    </button>
  </div>
</template>

<script>
export default {
  name: 'BuiltProgress',
  data(){
    return {
        buttonStyle: {}
    };
  },
  computed: {
    currentStep(){
        return this.$store.state.step;
    },
    steps(){
        return this.$store.state.steps;
    },
    done(){
        return this.$store.state.done;
    }
  },
  methods: {
    isCurrent(step){
        return step.index == this.currentStep.index;
    },
    isActive(step){
        return step.index <= this.currentStep.index;
    },
    isDone(step){
        return step.index < this.currentStep.index || this.done;
    },
    calcButtonStyle(){
        let buttonsContainer = this.$refs.progress,
            buttonsContainerWidth = buttonsContainer.offsetWidth,
            buttons = buttonsContainer.getElementsByTagName('button'),
            buttonsWidth = 0
        ;

        for(let i = 0; i < buttons.length; i++){

            buttonsWidth += buttons[i].offsetWidth;

        }

        this.buttonStyle = Object.assign({}, this.marginLeft, {marginRight: (buttonsContainerWidth - buttonsWidth - 0) / (buttons.length - 1) + 'px'});
    }
  },
  mounted(){

      this.calcButtonStyle();

      window.addEventListener('resize', this.calcButtonStyle)

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.built-progress{
  text-align: left;
  position: relative;
  box-sizing: border-box;

  &:before{
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    height: 1px;
    background-color: #ccc;
    z-index: -1;
  }

  button{
    background-color: #fff;
    padding: 25px 15px;
    border: none;
    outline: none;
    box-sizing: border-box;

    &:hover{
      /*background-color: #ececec;*/
      cursor: auto;
    }

    &:last-child{
      margin-right: 0 !important;
    }

    span{
      display: inline-block;
      width: 20px;
      height: 20px;
      line-height: 18px;
      border-radius: 15px;
      padding-top: 1px;
      background-color: #ccc;
      margin-right: 10px;
      transition: all 0.2s ease-in-out;
    }

    &.active span{
      background-color: cornflowerblue;
      color: #fff;
    }
  }
}
</style>
